import { Phone, X } from 'lucide-react';
import { useOverlayDrag } from './overlayDrag';
import { Keypad } from './Keypad';
import { usePhone } from './phone';

/**
 * The Twilio softphone's keypad, floating where the RingCentral dialer floats.
 *
 * It used to sit in a column on the Calls tab. Now the Calls tab is the log and
 * a New call control, and the pad comes out over it — the same shape as the
 * dialer beside it, so an agent learns one gesture for both phone systems.
 *
 * Deliberately only the pad. A ringing or connected Twilio call is the call
 * bar's, at the top of the module on every tab; PhoneProvider closes this the
 * moment a call starts, so the two are never on screen together.
 *
 * Nothing is drawn for a hosted phone: inside the dashboard the device, its
 * keypad and its panel are the shell's (see useHostPhone), and `showPanel`
 * there asks the dashboard to bring that one out instead.
 */
export function PhonePanel() {
  const phone = usePhone();
  const drag = useOverlayDrag();
  if (!phone || phone.hosted || !phone.inbox) return null;

  return (
    <div className={`rcdial rcdial-phone${phone.panelOpen ? ' open' : ''}`}>
      <div className="rcdial-head draggable" onPointerDown={drag.onPointerDown} title="Drag to move">
        <Phone size={14} />
        <span className="rcdial-title">Phone</span>
        <span className="rcdial-state">
          {phone.status === 'ready'
            ? 'Twilio · ready'
            : phone.status === 'connecting'
              ? 'Twilio · connecting…'
              : 'Twilio · not connected'}
        </span>
        <button type="button" className="rcdial-close" title="Hide keypad" onClick={phone.hidePanel}>
          <X size={13} />
        </button>
      </div>
      <div className="rcdial-body">
        <Keypad phone={phone} inbox={phone.inbox} />
      </div>
    </div>
  );
}
